import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import LoginApp from './LoginApp.tsx'
import { setupFetchInterceptor } from './utils/setupFetchInterceptor'

// 전역 fetch 인터셉터 설정 (401 에러 시 자동 로그아웃)
setupFetchInterceptor();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <LoginApp />
  </StrictMode>,
)
